export const GRIDPICKER_CONSTANTS = {
    statesKey : 'gridPicker.states'
};
